import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { EnglishRules, Rules, validationRules } from '@/support/ValidationRules';
import { Tag } from '@/models/Tag';

@Component<CreateDialog>({})
export default class CreateDialog extends Vue {
  @Prop({default: null})
  protected tag!: Tag;

  protected newTag: Tag = new Tag();
  protected isLoading: boolean = true;
  protected valid: boolean = false;
  protected rules: Rules = EnglishRules;

  mounted() {
    if(this.tag) {
      this.newTag = this.tag.clone();
    }
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }


  protected close() {
    this.$emit('input', false);
    this.clear();
  }

  protected createOrUpdate() {
    if(this.newTag.id) {
      this.update();
    } else {
      this.create();
    }
  }

  protected update() {
    this.isLoading = true;
    if(!this.newTag) {
      return;
    }

    this.newTag
      .update()
      .then((tag: Tag) => {
        this.isLoading = false;
        this.$emit('tagUpdated', tag);
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected create() {
    if (!this.canSaveTag) {
      return;
    }

    this.isLoading = true;
    this.newTag
    .create()
    .then((tag: Tag) => {
      this.isLoading = false;
      this.$emit('tagCreated');
      this.close();
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected get canSaveTag() {
    if(this.newTag && this.newTag.name && this.newTag.name.length > 0) {
      return true;
    }

    return false;
  }

  protected get saveButtonText() {
    if(this.newTag && this.newTag.id) {
      return 'Edit';
    }

    return 'Add';
  }

  protected clear() {
    this.newTag = new Tag();
  }
}
